import React from "react";
import { formatDistanceToNow } from "date-fns";
import {
  Card,
  CardExcerpt,
  CardTitleLink,
  MetaLink,
  MetaPill,
  MetaRow,
} from "./ForumStyles";

const truncate = (value, maxLength = 220) => {
  const text = String(value || "").trim();
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength - 3).trim()}...`;
};

const formatCreatedAt = (value) => {
  if (!value) return "Just now";

  try {
    return formatDistanceToNow(new Date(value), { addSuffix: true });
  } catch (_error) {
    return "Recently";
  }
};

function QuestionCard({ question }) {
  return (
    <Card>
      <MetaRow>
        <MetaPill $accent>{question.category}</MetaPill>
        {/* <MetaPill>{question.viewCount || 0} views</MetaPill> */}
        <MetaPill>Asked by {question.authorName || "Anonymous"}</MetaPill>
        <MetaPill>{formatCreatedAt(question.createdAt)}</MetaPill>
      </MetaRow>

      <CardTitleLink to={`/forum/${question.slug}`}>{question.title}</CardTitleLink>
      <CardExcerpt>{truncate(question.body)}</CardExcerpt>
      <MetaLink to={`/forum/${question.slug}`}>
       • {question.replyCount || 0} replies
      </MetaLink>
    </Card>
  );
}

export default QuestionCard;
